import { render, staticRenderFns } from "./StatusRecordTable.vue?vue&type=template&id=1972ac42"
import script from "./StatusRecordTable.vue?vue&type=script&lang=ts"
export * from "./StatusRecordTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports